import React, { useState, useEffect } from "react";
import { SetupDataPageTemplate } from "../../components/setup-pages/SetupDataPageTemplate";
import { Form, Field, FieldError } from "react-jsonschema-form-validation";
import { setupData } from "../../configs/routes";
import {
	getUserSettings,
	resetUserSettings,
	saveLongTermConditions,
} from "../../services/userService";
import { sanitize } from "dompurify";
import he from "he";
import { Checkbox } from "../../components/common/FormInputs";

export const LongTermConditions = () => {
	const schema = {
		type: "object",
	};

	const conditionOptions = [
		"None",
		"Diabetes",
		"Hyperthyroidism",
		"Chronic Kidney Disease",
		"Chronic Liver Disease",
		"COPD",
		"Asthma",
		"Hypertension",
		"Stroke or Transient Ischemic Attacks",
		"Atrial Fibrillation",
		"Heart Failure",
		"Coronary Heart Disease",
		"Mental Health",
		"Dementia",
		"Depression",
		"Epilepsy",
		"Other",
	];

	const headerDetails = {
		title: "Long Term Conditions",
		currentPage: 1,
		pageCount: 1,
	};

	const settings = getUserSettings().longTermConditions;

	const [selectedConditions, setSelectedConditions] = useState(
		settings.conditions
	);
	const [otherText, setOtherText] = useState(settings.otherText);

	const isChecked = (value) => {
		return selectedConditions.some((e) => e === value);
	};

	const toggleValue = (value) => {
		if (value === 0) {
			if (selectedConditions.length === 1 && selectedConditions[0] === 0) {
				setSelectedConditions([]);
			} else {
				setSelectedConditions([0]);
			}
		} else {
			const selection = selectedConditions.filter((e) => e !== 0);

			if (selection.some((e) => e === value)) {
				setSelectedConditions(selection.filter((e) => e !== value));
			} else {
				const temp = [...selection];
				temp.push(value);
				setSelectedConditions(temp);
			}
		}
	};

	const optionIsChecked = (optionName) => {
		return selectedConditions.some(
			(e) => e === conditionOptions.indexOf(optionName)
		);
	};

	const getMultiSelectElements = () => {
		return conditionOptions.map((e, index) => {
			return (
				<>
					<Field
						type="select"
						key={`condition${index}`}
						name={"condition"}
						id={`condition${index}`}
						className={"hidden"}
						checked={isChecked(index)}
						onClick={() => toggleValue(index)}
					/>
					<Checkbox
						htmlFor={`condition${index}`}
						key={`label${index}`}
						label={e}
						checked={isChecked(index)}
					/>
				</>
			);
		});
	};

	const onFinish = () => {
		return new Promise((resolve, reject) => {
			settings.conditions = selectedConditions;
			if (
				selectedConditions.some((e) => e === conditionOptions.indexOf("Other"))
			) {
				settings.otherText = otherText;
			} else {
				settings.otherText = "";
			}

			settings.complete = true;

			saveLongTermConditions(settings).then(resolve).catch(reject);
		});
	};

	const handleOtherChange = (value) => {
		const clean = sanitize(value);
		setOtherText(he.decode(clean));
	};

	useEffect(() => {
		if (!optionIsChecked("Other")) {
			setOtherText("");
		}
	}, []);

	return (
		<>
			<SetupDataPageTemplate
				headerDetails={headerDetails}
				backTo={setupData}
				nextTo={setupData}
				onClickBack={resetUserSettings}
				onClickNext={{ func: onFinish, async: true }}
				hideNext={selectedConditions.length === 0}
				nextTextOverride={"Finish"}
			>
				<Form schema={schema}>
					<p className={"text-lg sm:text-xl font-bold mb-1 sm:mb-2"}>
						Please indicate if you currently have a diagnosis with any of the
						following. Also, please come back here and update if you receive any
						new diagnoses at any time.
					</p>
					<p className={"mb-3 sm:mb-6"}>(please select all that apply)</p>
					<div>
						{getMultiSelectElements()}

						{optionIsChecked("Other") && (
							<div className={"formFieldContainer"}>
								<div className="flex-grow px-2 py-2">
									<Field
										type="text"
										key="otherText"
										className={"formField"}
										id={"otherText"}
										name="otherText"
										placeholder={"Other long term condition..."}
										value={otherText}
										disabled={!optionIsChecked("Other")}
										onChange={(e) => handleOtherChange(e.target.value)}
									/>
									<FieldError
										errorMessages={{
											required: () => "You must fill out all required fields",
										}}
										className={"rounded-b-sm"}
									/>
								</div>
							</div>
						)}
					</div>
				</Form>
			</SetupDataPageTemplate>
		</>
	);
};
